import React, { Component } from 'react';
import classNames from 'classnames';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import ContextMenu from './contexMenu';
import SearchBox from '../../portal/searchBox';
import { ToolBar } from '../toolbar';
import styles from './style.scss';
import { Redirect } from 'react-router-dom';
import { inject } from 'mobx-react';

@inject('rolesStore')

export default class RolesGrid extends Component {

    state = {
        goToEditRoleScreen: false
    };
    
    keywords = {
        searchLibrary: this.props.translations.searchRoles,
        clear: this.props.translations.clear
    };

    toolBar = props => <ToolBar {...props} translations={this.props.translations} roles={this.props.roles} onNewRoleClick={this.addRole} />;
    
    tableOptions = {
        sortIndicator: false,
        afterColumnFilter: this.afterFilter,
        noDataText: this.props.translations.noDataToDisplay,
        toolBar: this.toolBar,
        page: 1,
        sizePerPage: 10,
        afterTableComplete: this.handleTableComplete,
        searchField: props => <SearchBox keywords={this.keywords} sendSearchEvent={true} {...props}/>
    };

    formatRoleName = (cellText, rowData) => 
        <div
            className={classNames(styles.roleNameColumn, 'library-name-link ellipsis')}
            title={cellText}
        >
            {cellText}
        </div>;

    formatGeneric = cellText => 
        <div
            className='general-table-column ellipsis'
            title={cellText}
        >
            {cellText}
        </div>;

    formatRowMenu = (id, rowData) => {
    
        return <ContextMenu
                    id={id}
                    data={rowData}
                    translations={this.props.translations}
                    openDeleteDialog={this.props.openDeleteDialog}
                />;
    }

    UsersTotalCount = ({allUsersText, className}) =>
        <div className={className}>
            {allUsersText}
        </div>;

    addRole = () => {
        
        const role = 
                {
                    name: '',
                    description: '',
                    permissionIds: []
                };
                
                this.props.rolesStore.setEditRole(role);
        
        this.setState({
            goToEditRoleScreen: true
        });
    }

    render() {

        if(this.state.goToEditRoleScreen === true) {
            
            return <Redirect to={'/roles/0'} />;
        }
        
        let table = null;

        if (this.props.roles === undefined) {

            return null;
        }

        table = <BootstrapTable 
                    data={this.props.roles}
                    striped
                    hover
                    search
                    pagination
                    options={this.tableOptions}
                    tableContainerClass={styles.rolesTableContainerWrapper}
                    bodyContainerClass={styles.tableBodyWrapper}
                    headerContainerClass={styles.gridHeader}
                    trClassName='table-row'
                >
                    <TableHeaderColumn
                        isKey dataField='name'
                        className='table-header user-full-name-header-column'
                        ref='nameCol'
                        dataFormat={this.formatRoleName}
                        width='400'
                    >
                        <span className={styles.userName}>
                            {this.props.translations.roles}
                        </span>
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField='description'
                        className='table-header user-full-name-header-column'
                        dataFormat={this.formatGeneric}
                    >
                        {this.props.translations.description}
                    </TableHeaderColumn>

                    <TableHeaderColumn dataField='id' className='table-header'
                            dataFormat={this.formatRowMenu} width='60px'>
                    </TableHeaderColumn>
                </BootstrapTable>;

        return(
            <div>
                <div className='portal-grid'>
                    {table}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/roles/rolesGrid/grid.jsx